export class FeatureMaster {
    ID:number;

    CLIENT_ID:number;
    NAME:string;
 SHORT_CODE:string;
 STATUS:boolean=true;
 SEQUENCE_NO:number;
}